import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import SettingsApp from '../settings';
import AuthGoogle from '../components/authGoogle/index';

import Share from '../components/share/share';
import Picker from '../components/picker/Picker';
import PopupFile from '../../widget/components/popup/PopupFile';
import Widget from '../../widget/widget';

const SettingsRoutes = () => {
    const publicUrl = process.env.PUBLIC_URL;
    return(
        <BrowserRouter>
            <Switch>
                <Route path="/settings.html" exact render={(props) => <SettingsApp {...props} />} />
                <Route path="/settings" exact render={(props) => <SettingsApp {...props} />} />
                <Route path={publicUrl + "/settings/popup"}  exact render={(props) => <Picker  {...props} />} />
                <Route path={publicUrl + "/settings/share/:type"} exact render={(props) => <Share  {...props} />} />
                <Route path={publicUrl + "/settings/share/:edit"} exact render={(props) => <Share  {...props} />} />
                <Route path={publicUrl + "/settings/share/:publicwait"} exact render={(props) => <Share  {...props} />} />
                <Route path={publicUrl + "/settings/share/:wait"} exact render={(props) => <Share  {...props} />} />
                <Route path={"/widget.html"} exact render={(props) => <Widget {...props} />} />
                <Route path={publicUrl + "/widget"} exact render={(props) => <Widget {...props} />} />
                <Route path={publicUrl + "/widget/popup/:src/:height/:width/:deviceType"} exact render={(props) => <PopupFile  {...props} />} />    
            </Switch>
        </BrowserRouter>
        
    );
}
export default SettingsRoutes;


// WEBPACK FOOTER //
// ./src/settings/routes/index.js